// extracted by mini-css-extract-plugin
export var disabled = "_7z-5";
export var fileName = "_7z-b";
export var filePreview = "_7z-4";
export var hoverFilter = "_7z-6";
export var imageButton = "_7z-3 _7z-6";
export var imageButtonContainer = "_7z-2";
export var input = "_7z-7";
export var removeButton = "_7z-0";
export var removeButtonFile = "_7z-1";
export var spinner = "_7z-9";
export var spinnerContainer = "_7z-8";
export var videoContainer = "_7z-a _7z-6";